import React, { useEffect, useState } from "react";
import { EMB } from "./hoc/data";
import "./hoc/hoc.css";
import "./hoc/game.css";

const ASSET_BASE = `${process.env.PUBLIC_URL || ""}/hoc/assets`;

/** Same fixed-frame scaling the game engine uses: desktop 1920x1080, phone 414x896. */
function useFrame() {
  const calc = () => {
    const W = window.innerWidth, H = window.innerHeight;
    const mobile = W / H < 0.82;
    const fw = mobile ? 414 : 1920, fh = mobile ? 896 : 1080;
    const scale = Math.min(W / fw, H / fh);
    // fill the window: stretch the frame along the looser side instead of leaving bars
    return { mobile, scale, width: W / scale, height: H / scale };
  };
  const [f, setF] = useState(calc);
  useEffect(() => {
    const on = () => setF(calc());
    window.addEventListener("resize", on);
    return () => window.removeEventListener("resize", on);
  }, []);
  return f;
}

const FONTS_HREF =
  "https://fonts.googleapis.com/css2?family=Unbounded:wght@500;700;800&family=Figtree:wght@400;600;700;800&display=swap";

/** The game's opening title screen, shown on the login page. `onStart` moves on to the game. */
export default function Splash({ onStart, logo }) {
  useEffect(() => {
    if (document.querySelector("link[data-hoc-fonts]")) return;
    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.href = FONTS_HREF;
    link.setAttribute("data-hoc-fonts", "1");
    document.head.appendChild(link);
  }, []);

  const { mobile, scale, width, height } = useFrame();
  const px = mobile ? 64 : 120;

  return (
    <div className="hoc-root" style={{ position: "fixed", inset: 0, zIndex: 950 }}>
      <div id="stage" style={{ inset: 0 }}>
        <div
          className={`frame ${mobile ? "m" : "d"}${logo ? " has-logo" : ""}`}
          style={{ position: "absolute", left: 0, top: 0, width, height, transform: `scale(${scale})`, transformOrigin: "0 0" }}
        >
          <div className="screen s-entry">
            <img className="bg" src={`${ASSET_BASE}/bg/house-exterior-${mobile ? "mobile" : "desktop"}.jpg`} alt="" />
            <div className="scrim heavy" />
            {logo && <img className="partner-logo" src={logo} alt="" aria-hidden="true" draggable={false} />}
            <div className="layer entry">
              <div className="title">
                <div className="emblem pulse" style={{ width: px, height: px }} dangerouslySetInnerHTML={{ __html: EMB }} />
                <div className="k">BIG BOSS</div>
                <h1>
                  Customer Centric <em>League</em>
                </h1>
                <p className="tag">Four tasks. Four rivals. One spotlight.</p>
              </div>
              <div className="panel card" style={{ alignItems: "center", textAlign: "center" }}>
                <p className="mute" style={{ fontSize: mobile ? 14 : 19 }}>
                  A reality show challenge on customer experience. Voice and music are on. You can switch them off any time.
                </p>
                <button type="button" className="btn block" onClick={onStart}>
                  Start the Season <span className="i i-arrow" aria-hidden="true" />
                </button>
                <div className="meta">
                  <span className="chip dim">4 tasks</span>
                  <span className="chip dim">Self-paced</span>
                  <span className="chip dim">Voice &amp; music on</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
